<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
    mounted: function () {
        this.startPendingCountTimer();
    },
    methods: {
        startPendingCountTimer: function () {
            let _this = this;
            setInterval(function () {
                _this.checkPendingCount();
            }, 120000);
        },
        checkPendingCount: function () {
            this.lib.checkPendingCount();
        }
    }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/App.vue